/**
 * Compares two version strings to determine if the first version is greater than or equal to the second version.
 *
 * @param {string} v1 - The first version string in the format "major.minor.patch".
 * @param {string} v2 - The second version string in the format "major.minor.patch".
 * @returns {boolean} - Returns true if v1 is greater than or equal to v2, otherwise false.
 */
export const compareVersions = (v1, v2) => {
  // verify that the version strings are in the correct format
  const isValidVersion = (version) => /^\d+\.\d+\.\d+$/.test(version);

  if (!isValidVersion(v1) || !isValidVersion(v2)) {
    throw new Error('Invalid version format. Versions must be in the format x.y.z where x, y, and z are numbers.');
  }

  const [major1, minor1, patch1] = v1.split('.').map(Number);
  const [major2, minor2, patch2] = v2.split('.').map(Number);

  if (major1 !== major2) return major1 > major2;
  if (minor1 !== minor2) return minor1 > minor2;
  return (patch1 || 0) >= (patch2 || 0);
};


